"use client";
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import backend from "i18next-http-backend"; 


i18n
.use(LanguageDetector)
.use(initReactI18next)
.use(backend)
.init({
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    crossDomain: false
  },
  ns: ['translation'],
  defaultNS: 'translation',
  partialBundledLanguages: true,
  load: 'languageOnly',
  detection: {
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
    lookupLocalStorage: "i18nextLng",
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  }, 
  })

